const openInNewTab = (url: string) => {
  window.open(url, "_blank", "noreferrer");
};

export default openInNewTab;
